import { render, staticRenderFns } from "./InsightDetails.vue?vue&type=template&id=432df64b"
import script from "./InsightDetails.vue?vue&type=script&lang=js"
export * from "./InsightDetails.vue?vue&type=script&lang=js"
import style0 from "./InsightDetails.vue?vue&type=style&index=0&id=432df64b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports